import React from "react";
import Typewriter from "typewriter-effect";

function Type() {
  return (
    <Typewriter
      options={{
        strings: [
          "Full Stack Software Engineer",
          "Building Scalable Web Applications",
          "React.js • Next.js • Node.js",
          "PostgreSQL • Prisma ORM",
          "Clean Code • Performance • Problem Solving",
        ],
        autoStart: true,
        loop: true,
        deleteSpeed: 50,
      }}
    />
  );
}

export default Type;
